import SiteConfiguration from '@/pages/settings/site-configuration'
import { createFileRoute } from '@tanstack/react-router'

export const Route = createFileRoute(
  '/(protected)/settings/configuration'
)({
  component: SiteConfiguration,
})